import React from 'react';
import { KeyboardArrowDown } from '@styled-icons/material-outlined';
import { FloatingMenu } from '@increasecard/typed-components';
import { NavItemConfig } from './NavBar.types';
import { SubNavItem } from './SubNavItem';
import {
  StyledNavLink,
  IconWrapper,
  ChevronWrapper,
  FloatingSubNavList,
  SubNavWrapper,
  SubNavList,
  CustomTCLink,
} from './NavBar.styles';

interface NavItemProps {
  item: NavItemConfig;
  isCollapsed: boolean;
  isExpanded: boolean;
  onToggle: (path: string) => void;
}

export const NavItem: React.FC<NavItemProps> = ({ item, isCollapsed, isExpanded, onToggle }) => {
  const hasChildren = item.children && item.children.length > 0;

  const handleMainClick = () => {
    if (hasChildren && !isCollapsed) {
      onToggle(item.path);
    }
  };

  const renderSubItems = () => {
    return item.children
      ?.filter((child) => !child.hidden)
      .map((child) => {
        if (child.isExternal) {
          return (
            <li>
              <CustomTCLink href={child.path} target="_blank" small>
                {child.title}
              </CustomTCLink>
            </li>
          );
        }
        return <SubNavItem key={child.path} child={child} />;
      });
  };

  if (item.isExternal) {
    return (
      <CustomTCLink href={item.path} target="_blank">
        {item.title}
      </CustomTCLink>
    );
  }

  const trigger = (
    <StyledNavLink
      to={item.path}
      exact={item.exact}
      activeClassName="active"
      onClick={handleMainClick}
      $isCollapsed={isCollapsed}
    >
      {item.icon && (
        <IconWrapper>
          <item.icon />
        </IconWrapper>
      )}
      {!isCollapsed && (
        <>
          {item.title}
          {hasChildren && (
            <ChevronWrapper $isExpanded={isExpanded}>
              <KeyboardArrowDown />
            </ChevronWrapper>
          )}
        </>
      )}
    </StyledNavLink>
  );

  return (
    <li>
      {isCollapsed && hasChildren ? (
        <FloatingMenu
          renderTrigger={(triggerProps, { setShowMenu }) => (
            <div
              {...triggerProps}
              onMouseOver={() => setShowMenu(true)}
              onMouseOut={() => setShowMenu(false)}
              onFocus={() => setShowMenu(true)}
              onBlur={() => setShowMenu(false)}
            >
              {trigger}
            </div>
          )}
        >
          {({ setShowMenu }) => (
            <FloatingSubNavList
              onMouseEnter={() => setShowMenu(true)}
              onMouseLeave={() => setShowMenu(false)}
              onClick={() => setShowMenu(false)}
            >
              {renderSubItems()}
            </FloatingSubNavList>
          )}
        </FloatingMenu>
      ) : (
        <>
          {trigger}
          {hasChildren && !isCollapsed && (
            <SubNavWrapper $isExpanded={isExpanded}>
              <div className="for-animation">
                <SubNavList>{renderSubItems()}</SubNavList>
              </div>
            </SubNavWrapper>
          )}
        </>
      )}
    </li>
  );
};
